import { render, staticRenderFns } from "./SeatList.vue?vue&type=template&id=a5fcf38c&scoped=true&"
import script from "./SeatList.vue?vue&type=script&lang=js&"
export * from "./SeatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fcf38c",
  null
  
)

export default component.exports